import React, { useState } from "react";
import RemoveIcon from "../../../../assets/cp-delete-photo.svg";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  useUpdateCoverPictureMutation,
  useUpdatePictureTitleMutation,
} from "../../../../rtk-query/slices/createProduct/ProductInfo/productInfoSlice";
import Cover from "../../../../assets/cover.svg";
import { Spinner } from "react-bootstrap";
import { SortableElement, SortableHandle } from "react-sortable-hoc";

const CPPhoto = ({ res, id, handleRemovePhoto, productId }) => {
  const navigate = useNavigate();
  const [updatePictureTitle] = useUpdatePictureTitleMutation();
  const [updateCoverPicture, { isLoading }] = useUpdateCoverPictureMutation();
  const [caption, setCaption] = useState(res?.product_image_title || null);

  const handleCaptionChange = (e) => {
    setCaption(e.target.value);
  };

  const handleBlur = async (e) => {
    if (e.target.value === "") {
      setCaption(res?.product_image_title);
    } else if (e.target.value === res?.product_image_title) {
      setCaption(res?.product_image_title);
    } else {
      try {
        const formData = new FormData();

        formData.append("product_id", productId || localStorage.getItem("productId") || null); // Ensure this key is correct based on your API
        formData.append("title", e.target.value);
        formData.append("picture_id", res?.image_id);
        formData.append("sort_order", 1);

        const response = await updatePictureTitle(formData);

        if (response?.data?.status) {
          toast.success(response?.data?.message, {
            position: "top-center",
            autoClose: 3000,
          });
          // navigate("/");
        }
        if (response?.error) {
          const errors = response?.error?.data?.errors;
          if (response?.error?.status === 401) {
            localStorage.removeItem("DODLoginToken");
            toast.error(response?.error?.data?.message, {
              position: "top-center",
              autoClose: 3000,
            });
            navigate("/login");
          } else if (errors) {
            for (const field in errors) {
              if (errors.hasOwnProperty(field)) {
                // const combinedErrors = errors[field].join(" ");
                // if (field === "supplier_type") {
                //   setFieldError("option", combinedErrors);
                // }
              }
            }
            toast.error(response?.error?.data?.message, {
              position: "top-center",
              autoClose: 3000,
            });
          } else {
            toast.error(response?.error?.data?.message, {
              position: "top-center",
              autoClose: 3000,
            });
          }
        }
      } catch (error) {
        console.log(error);
        toast.error("An unexpected error occurred. Please try again.", {
          position: "top-center",
          autoClose: 3000,
        });
      }
    }
  };

  const handleAddCover = async () => {
    try {
      const formData = new FormData();

      formData.append("product_id", productId || localStorage.getItem("productId") || null); // Ensure this key is correct based on your API
      formData.append("is_default_image", 1);
      formData.append("picture_id", res?.image_id);
      formData.append("type", "0");

      const response = await updateCoverPicture(formData);

      if (response?.data?.status) {
        toast.success(response?.data?.message, {
          position: "top-center",
          autoClose: 3000,
        });
        // navigate("/");
      }
      if (response?.error) {
        const errors = response?.error?.data?.errors;
        if (response?.error?.status === 401) {
          localStorage.removeItem("DODLoginToken");
          toast.error(response?.error?.data?.message, {
            position: "top-center",
            autoClose: 3000,
          });
          navigate("/login");
        } else if (errors) {
          for (const field in errors) {
            if (errors.hasOwnProperty(field)) {
              // const combinedErrors = errors[field].join(" ");
              // if (field === "supplier_type") {
              //   setFieldError("option", combinedErrors);
              // }
            }
          }
          toast.error(response?.error?.data?.message, {
            position: "top-center",
            autoClose: 3000,
          });
        } else {
          toast.error(response?.error?.data?.message, {
            position: "top-center",
            autoClose: 3000,
          });
        }
      }
    } catch (error) {
      console.log(error);
      toast.error("An unexpected error occurred. Please try again.", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="selected-photo-card">
      {/* <SortableHandle className="sortable-handle"> */}
      <img
        src={res?.product_image_filename}
        alt={`uploaded-img-${id}`}
        className="cp-photo-thumbnail"
      />
      <input
        type="text"
        value={caption}
        placeholder="Add Cover Caption"
        onChange={handleCaptionChange}
        onBlur={handleBlur}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault(); // Prevent the default behavior of the Enter key
            e.target.blur(); // Remove focus from the input field
            // handleBlur(e);
          }
        }}
      />
      <button
        className="remove-photo-icon"
        onClick={(e) => {
          e.preventDefault();
          handleRemovePhoto(res?.image_id);
        }}
      >
        {/* <img src={RemoveIcon} className="" alt="remove-icon" /> */}
      </button>
      {res?.is_default_image === 1 && (
        <button
          // src={Cover}
          className="cover-photo-icon"
          alt="cover-icon"
          onClick={() => {
            return;
          }}
        >
          Cover
        </button>
      )}
      {res?.is_default_image === 0 && (
        <button
          // src={Cover}
          className="cover-photo-icon add-cover-icon"
          alt="cover-icon"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleAddCover();
          }}
        >
          Add cover {isLoading && <Spinner size="sm" className="ms-1" />}
        </button>
      )}
      {/* </SortableHandle> */}
    </div>
  );
};

export default CPPhoto;
